import { FileContent, FileContentFactory, Dependencies, DependenciesFactory } from ".."

export interface CreateBenefit {
    isDraft: boolean
    isActive: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    image: FileContent
    categoryIds: string[]
    dependencies: Dependencies | null
}

export class CreateBenefitFactory {
    static create(): CreateBenefit {
        return {
            isDraft: false,
            isActive: false,
            names: {
                hr: "",
                en: "",
            },
            descriptions: {
                hr: "",
                en: "",
            },
            image: FileContentFactory.create(),
            categoryIds: [],
            dependencies: DependenciesFactory.create(),
        }
    }
}
